import { compose } from 'redux';
import HomePage from '../components/accounts/HomePage';

import {withAllProducts} from './withAllProducts';
import {withCurrentUser} from './withUser';

export default compose(
  withAllProducts,
  withCurrentUser
)(
  HomePage
);


// WEBPACK FOOTER //
// ./src/containers/HomePage.js